import { Navigate, Outlet } from 'react-router-dom';
import { usePermissions } from '@/hooks/usePermissions';

/**
 * Hides a route branch from users without the permission.
 *
 * Convenience only — the API enforces the same rule, and is the check that actually protects data.
 */
export function RequirePermission({ permission }: { permission: string }) {
  const { can } = usePermissions();

  if (!can(permission)) return <Navigate to="/unauthorized" replace />;

  return <Outlet />;
}
